"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCodeFactory = exports.PLACEHOLDER_TOKEN = void 0;
const errors_1 = require("./errors");
exports.PLACEHOLDER_TOKEN = '%c';
const REPLACE_PATTERN = new RegExp(exports.PLACEHOLDER_TOKEN, 'g');
function formatCodeFactory(format) {
    if (!format.includes(exports.PLACEHOLDER_TOKEN)) {
        throw errors_1.ERRORS.MISSING_PLACEHOLDER_IN_CODE_FORMAT(format);
    }
    return (code) => {
        return format.replace(REPLACE_PATTERN, String(code));
    };
}
exports.formatCodeFactory = formatCodeFactory;
